/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

import { useOidcAccessToken } from "@axa-fr/react-oidc";

const GetTokenValues = () => {
  const tokenValues = useOidcAccessToken();
  return tokenValues;
};

export default GetTokenValues;
